import { render, staticRenderFns } from "./noticeRight.vue?vue&type=template&id=7b6cb2c8&scoped=true"
import script from "./noticeRight.vue?vue&type=script&lang=js"
export * from "./noticeRight.vue?vue&type=script&lang=js"
import style0 from "./noticeRight.vue?vue&type=style&index=0&id=7b6cb2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6cb2c8",
  null
  
)

export default component.exports